import React, { useEffect } from "react";

import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import "./App.css";
import "./mediaCss.css";
import "./Banner.css";
import "./Style.css";
import "./NewLP.css";

// import '@tabler/icons-webfont/css/tabler-icons.min.css';
import "bootstrap/dist/css/bootstrap.min.css";

import NotFoundPage from "./404Page";
import ErrorBoundary from "./components/common/ErrorBoundary";
import LP from "./components/LP/LP";
import Thankyou from "./components/common/ThankYou";

const App = () => {
  useEffect(() => {
    const rootDiv = document.getElementById("root");
    if (!rootDiv || rootDiv.innerHTML.trim() === "") {
      // Redirect to 404 page if the root div is empty
      window.location.replace("/404");
    }
  }, []);
  return (
    <Router>
      <ErrorBoundary>
        <Routes>
          <Route path="/lp" element={<LP />} />
          <Route path="/" element={<LP />} />
          <Route path="/404" Component={NotFoundPage} />
          <Route path="/thank-you" element={<Thankyou />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
};

export default App;
